import { Input, message, notification, Tooltip, Form, Divider } from "antd";
import React, { createContext, useContext, useRef } from "react";
import moment from "moment";
import Dragger from "antd/lib/upload/Dragger";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { ENV } from "../../../Infrastructure/EnvironmentConfig";
import { MessageBar, MessageBarType, ProgressIndicator } from "@fluentui/react";
import { Link } from "react-router-dom";
import { UploadCloud } from "react-feather";
import { observer } from "mobx-react-lite";
import WizardStore from "../store/wizardstore";

import formatNumber from "accounting-js/lib/formatNumber";
import { toJS } from "mobx";

const wizardStoreCtx = createContext(WizardStore);
const _ = require("underscore");
export const ConsumptionEntry = observer(() => {
  const wizardStore = useContext(wizardStoreCtx);

  const materialGrid = useRef(null);
  const uploadprops = {
    name: "file",
    accept: ".xls,.xlsx",
    multiple: false,
    beforeUpload: (file, fileList) => {
      if (_.isEmpty(wizardStore.sheetName)) {
        notification.error({
          key: "error",
          message: "SPARS Feedback",
          description:
            "input deck sheet name is required,enter the field production report sheetname",
        });

        return false;
      }
      return true;
    },
    headers: {
      method: "Post",
    },
    data: "newtemplate",
    action: `${ENV.API_ROOT}/material/ImportConsumption?sheetName=${wizardStore.sheetName}&assetId=${wizardStore.materialStore.mainStore.assetContextId}`,

    onChange(info) {
      try {
        const { status } = info.file;

        if (status === "done") {
          let { consumptionData = [], errors } = info.file.response;

          if (errors.length) {
            let idx = 0;
            errors.forEach((e) => {
              idx++;
              wizardStore.uploadErrors.set(idx, e);
            });

            console.log(
              "err",
              [...wizardStore.uploadErrors.values()].map((e) => toJS(e))
            );
          } else {
            wizardStore.importConsumptions.clear();
            consumptionData.forEach((c) =>
              wizardStore.importConsumptions.set(c.chemicalId, c)
            );

            wizardStore.uploadErrors = [];
          }
        } else if (status === "error") {
          wizardStore.showUploadErrorMessage = true;
          message.error(`${info.file.name} file preview failed.`);
          notification.error({
            message: "SPARS Feedback",
            description: `${info.file.response}`,
          });
        }
      } catch (error) {
        message.error(`${info.file.name} file preview failed.`);
      }
    },
  };
  const formatDigitOil = (params) => {
    const { value } = params;
    // this puts commas into the number eg 1000 goes to 1,000,
    // i pulled this from stack overflow, i have no idea how it works
    if (value) {
      return formatNumber(value, {
        precision: 2,
        thousand: ",",
      });
    }
  };
  const gridcolumnDefs = {
    columnDefs: [
      {
        headerName: "#",
        valueGetter: "node.rowIndex + 1",
        width: 50,
        resizable: true,
        sortable: true,
      },
      {
        rowDrag: true,

        width: 70,
        checkboxSelection: true,
      },
      {
        headerName: "Chemical",
        field: "chemicals",
        width: 180,
        resizable: true,
        sortable: true,
      },
      {
        headerName: "Units",
        field: "units",
        width: 80,
        resizable: true,
        sortable: true,
      },
      {
        headerName: "Previous Stock",
        field: "openingStock",
        width: 100,
        resizable: true,
        sortable: true,
        cellStyle: {
          textAlign: "right",
        },
        editable: false,
        type: "numberColumn",
        valueFormatter: formatDigitOil,
      },
      {
        headerName: "Usage",
        field: "usage",
        width: 100,
        resizable: true,
        sortable: true,
        cellStyle: {
          textAlign: "right",
          backgroundColor: "#FFF4CE",
        },
        editable: true,
        type: "numberColumn",
        valueFormatter: formatDigitOil,
      },
    ],
  };

  return (
    <div className="ms-Grid" dir="ltr">
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <MessageBar messageBarType={MessageBarType.info} isMultiline={false}>
            Don't have Materials Consumption Sheet template?
            <Link
              underline
              onClick={async () => {
                try {
                  await wizardStore.DownlaodTemplate();
                } catch (error) {
                  notification.error({
                    message: "SPARS Feedback",
                    description: error.message,
                  });
                }
              }}
            >
              Click to Download.
            </Link>
          </MessageBar>
        </div>
      </div>

      <div>
        {[...wizardStore.uploadErrors.values()]
          .map((e) => toJS(e))
          .map((e) => (
            <MessageBar messageBarType={MessageBarType.error}>
              {e.message}
            </MessageBar>
          ))}
      </div>

      {wizardStore.isDownloadingTemplate && (
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            {" "}
            <ProgressIndicator
              description="downloading, please wait..."
              styles={{ root: { textAlign: "center" } }}
            ></ProgressIndicator>
          </div>
        </div>
      )}
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <Form layout="vertical">
            <Form.Item
              label={<span style={{ color: "red" }}>Production Date*</span>}
            >
              <Tooltip title="Ebendo field production date">
                <span>
                  {moment(wizardStore.productionDate).format(
                    "dddd MMMM Do YYYY"
                  )}
                </span>
              </Tooltip>
            </Form.Item>

            <Form.Item
              label={
                <span style={{ color: "red" }}>Input Deck WorkSheet *</span>
              }
            >
              <Tooltip title="enter the sheetname  of the browsed materials consumption  workbook">
                <Input
                  placeholder="Worksheet Name"
                  value={wizardStore.sheetName}
                  name="nem"
                  onChange={({ target }) => {
                    wizardStore.sheetName = target.value;
                  }}
                />
              </Tooltip>
            </Form.Item>
            <Form.Item>
              <Dragger
                style={{
                  width: "100%",
                  backgroundColor: "transparent",
                }}
                multiple={false}
                {...uploadprops}
              >
                <p className="ant-upload-drag-icon">
                  <UploadCloud size={60} style={{ color: "#68D391" }} />
                </p>
                <p className="ant-upload-text">
                  Browse for material consumption Input template
                </p>
              </Dragger>
            </Form.Item>
          </Form>
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <Divider>Data Preview</Divider>
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <MessageBar
            messageBarType={MessageBarType.warning}
            isMultiline={false}
          >
            Double click usage column to edit.
          </MessageBar>
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <div
            className="ag-theme-balham"
            style={{
              minHeight: "40vh",
              height: "40vh",
              width: "100%",
            }}
          >
            <AgGridReact
              rowData={[...wizardStore.importConsumptions.values()]}
              ref={materialGrid}
              gridOptions={{
                defaultColDef: {
                  sortable: true,
                  filter: true,
                  enableValue: true,
                },

                rowSelection: "single",
                pagination: true,
                columnDefs: gridcolumnDefs.columnDefs,
                animateRows: true,

                columnTypes: {
                  nonEditableColumn: { editable: false },
                },
              }}
              rowSelection="single"
              copyHeadersToClipboard={true}
              overlayLoadingTemplate={`${(
                <span class="ag-overlay-loading-center">
                  Please wait while your rows are loading
                </span>
              )}`}
              overlayNoRowsTemplate={
                '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">No Result</span>'
              }
            ></AgGridReact>
          </div>
        </div>
      </div>
    </div>
  );
});

